import EF from 'ef/ef';

const PageService = function () {
  this.saveProgress = function (blockView) {
    EF.module.progress.save(blockView.model);
  };
};

export default new PageService();
